import { customEventFactory } from './customEventFactory';

const APEX_EVENT_TYPE = {
  SendOrder: 'SendOrder',
};

const APEX_EVENTS_TO_TRACK_MAP = Object.values(APEX_EVENT_TYPE).reduce((acc, eventType) => {
  acc[eventType] = true;
  return acc;
}, {});

class NewRelicService {
  isSubscriptionActive = false;
  originalNext = null;
  requestMap = {};

  /**
   * @returns {Record<string, any> | null}
   */
  getInstance() {
    const newRelic = window.newrelic;
    if (!newRelic) {
      console.warn('New Relic is not loaded. Events will not be tracked.');
      return null;
    }

    return newRelic;
  }

  subscribeToApexEvents(apex) {
    // TODO: temp
    window.apex = apex;

    if (!this.originalNext) {
      this.originalNext = apex.connection.ws.next.bind(apex.connection.ws);
    }

    /**
     * Monkey patch for ws.next to intercept outgoing messages (requests)
     */
    apex.connection.ws.next = (...args) => {
      try {
        this.onRequestSend(args[0]);
      } catch (error) {
        console.debug('NewRelicService.subscribeToApexEvents Debug. Failed to process message.', { args, error });
        // Not throw error to not block original function execution
      }

      //   Leave original function untouched
      this.originalNext(...args);
    };

    /**
     * Interceptor for WS response messages
     */
    apex.connection.ws.subscribe((data) => {
      const newRelic = window.newrelic;
      if (!newRelic) {
        console.error('Error. New Relic is not loaded. Events will not be tracked.');
        return;
      }

      const eventType = data.n;
      const messageId = data.i;
      const response = JSON.parse(data?.o || '{}');
      const request = this.#getRequest(messageId, eventType);

      if (eventType === APEX_EVENT_TYPE.SendOrder) {
        customEventFactory.sendOrderOutcome({ newRelic, request, response });
      }

      // Delete message once we process response to not cause memory leak
      delete this.requestMap[messageId];
    });

    this.isSubscriptionActive = true;
  }

  onRequestSend(data) {
    let message = {};
    try {
      message = JSON.parse(data || '{}');
    } catch (error) {
      console.debug('NewRelicService.subscribeToApexEvents Debug. Failed to parse message.', { data, error });
    }

    const eventType = message.n;
    const messageId = message.i;
    const payload = JSON.parse(message.o || '{}');

    // Save requests we want to track
    if (APEX_EVENTS_TO_TRACK_MAP[eventType]) {
      this.requestMap[messageId] = { eventType, payload };
    }
  }

  /**
   * @param {string} messageId
   * @param {string} eventType
   * @returns
   */
  #getRequest(messageId, eventType) {
    const request = this.requestMap[messageId];
    const isTrackedEvent = APEX_EVENTS_TO_TRACK_MAP[eventType];

    if (isTrackedEvent && !request) {
      console.warn('Error. Request not found. Event will not be tracked.', { messageId, eventType });
      return;
    }

    return request;
  }
}

export const newRelicService = new NewRelicService();
